module.exports = __webpack_public_path__ + "static/media/departures.d92cb42e.svg";